export function WorkInProgress() {
    return <h1>WorkInProgress</h1>;
}
